import PropTypes from 'prop-types'
import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const VARIANTS = {
  error: {
    title: 'Erreur',
    icon: 'fa-info-circle',
    background: '#ffebee',
    color: '#b71c1c',
    titleColor: '#b71c1c'
  },
  info: {
    title: 'Information',
    icon: 'fa-info-circle',
    background: '#e1effe',
    color: '#1c64f2',
    titleColor: '#1e429f'
  },
  success: {
    title: 'Succès',
    icon: 'fa-info-circle',
    background: '#def7ec',
    color: '#057a55',
    titleColor: '#03543f'
  },
  warning: {
    title: 'Attention',
    icon: 'fa-exclamation-circle',
    background: '#fdf6b2',
    color: '#9f580a',
    titleColor: '#723b13'
  }
}

const styles = {
  closeButton: {
    alignSelf: 'center',
    background: 'none',
    border: 'none',
    color: '#6b7280',
    cursor: 'pointer',
    fontSize: '12px',
    padding: 0
  },
  container: { bottom: '16px', position: 'fixed', right: '16px', width: '572px' },
  content: { alignItems: 'center', display: 'flex', flex: 1, gap: '16px' },
  icon: { flexShrink: 0, fontSize: '16px' },
  message: { fontSize: '14px', fontWeight: 400 },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: '2px',
    lineHeight: 1.5,
    minWidth: 0,
    wordBreak: 'break-word'
  },
  title: { fontSize: '16px', fontWeight: 600 },
  toast: {
    borderRadius: '4px',
    boxShadow: '0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    minHeight: 'auto',
    padding: '16px',
    width: '100%'
  }
}

const renderCloseButton = ({ closeToast }) => (
  <button style={styles.closeButton} type="button" onClick={closeToast}>
    <i className="fas fa-times" />
  </button>
)

const renderContent = (message, variant) => {
  const { icon, title, titleColor, color } = VARIANTS[variant]

  return (
    <div style={styles.content}>
      <i className={`fas ${icon}`} style={{ ...styles.icon, color }} />
      <span style={styles.textBlock}>
        <span style={{ ...styles.title, color: titleColor }}>{title}</span>
        <span style={{ ...styles.message, color }}>{message}</span>
      </span>
    </div>
  )
}

export const showToast = (message, variant = 'success', containerId = null) => {
  toast(renderContent(message, variant), {
    autoClose: 5000,
    closeOnClick: true,
    containerId,
    draggable: false,
    hideProgressBar: true,
    icon: false,
    pauseOnHover: true,
    position: 'bottom-right',
    style: { ...styles.toast, backgroundColor: VARIANTS[variant].background }
  })
}

const Toast = ({ containerId }) => (
  <ToastContainer
    autoClose={5000}
    closeButton={renderCloseButton}
    containerId={containerId}
    draggable={false}
    position="bottom-right"
    style={styles.container}
    hideProgressBar
    newestOnTop
    pauseOnFocusLoss
    pauseOnHover
  />
)

Toast.propTypes = {
  containerId: PropTypes.string.isRequired
}

export default Toast
